export const API = process.env.REACT_APP_API_URL;

export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL;

export const DOCUMENTS_URL = process.env.REACT_APP_DOCUMENTS_URL;

